const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function sendContact({ name, email, message }) {
  const res = await fetch(`${API}/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, email, message }),
  });
  if (!res.ok) throw new Error("Failed to send message");
  return res.json();
}

export async function listContact(token) {
  const res = await fetch(`${API}/contact`, { headers: { "X-Admin-Token": token || "" } });
  if (res.status === 401) throw new Error("Wrong admin token");
  if (!res.ok) throw new Error("Failed");
  return res.json();
}

async function openStream(sessionId, message, history, lang) {
  const res = await fetch(`${API}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message, history, lang }),
  });
  if (!res.ok || !res.body) throw new Error(`chat stream failed (${res.status})`);
  return res;
}

export async function streamChat({ sessionId, message, history, lang = "en", onDelta, onDone, onError }) {
  let res;
  try {
    res = await openStream(sessionId, message, history, lang);
  } catch {
    await new Promise((r) => setTimeout(r, 1500));
    try {
      res = await openStream(sessionId, message, history, lang);
    } catch (e) {
      onError?.(e);
      return;
    }
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    onDone?.();
  };
  try {
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trim();
      try {
        const obj = JSON.parse(payload);
        if (obj.delta) onDelta?.(obj.delta.replace(/\*\*/g, ""));
        if (obj.done) finish();
        if (obj.error) onError?.(new Error(obj.error));
      } catch {
        /* ignore keep-alives */
      }
    }
  }
  } catch (e) {
    onError?.(e);
    return;
  }
  finish();
}

const adminHeaders = (token) => ({ "Content-Type": "application/json", "X-Admin-Token": token || "" });

async function adminFetch(token, path, opts = {}) {
  const res = await fetch(`${API}${path}`, { ...opts, headers: adminHeaders(token) });
  if (res.status === 401) throw new Error("Wrong admin token");
  if (!res.ok) throw new Error(`Request failed (${res.status})`);
  return res.json();
}

export const roleMap = {
  list: (t) => adminFetch(t, "/role-sessions"),
  create: (t, body) => adminFetch(t, "/role-sessions", { method: "POST", body: JSON.stringify(body) }),
  get: (t, id) => adminFetch(t, `/role-sessions/${id}`),
  patch: (t, id, body) => adminFetch(t, `/role-sessions/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (t, id) => adminFetch(t, `/role-sessions/${id}`, { method: "DELETE" }),
  addEntry: (t, id, body) => adminFetch(t, `/role-sessions/${id}/entries`, { method: "POST", body: JSON.stringify(body) }),
  removeEntry: (t, id, eid) => adminFetch(t, `/role-sessions/${id}/entries/${eid}`, { method: "DELETE" }),
  suggest: (t, id) => adminFetch(t, `/role-sessions/${id}/suggest`, { method: "POST" }),
  patchProfile: (t, id, profile) => adminFetch(t, `/role-sessions/${id}/profile`, { method: "PATCH", body: JSON.stringify({ profile }) }),
  summary: (t, id) => adminFetch(t, `/role-sessions/${id}/summary`, { method: "POST" }),
};
